import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=a2e1f30a&scoped=true"
import script from "./Plan.vue?vue&type=script&lang=js"
export * from "./Plan.vue?vue&type=script&lang=js"
import style0 from "./Plan.vue?vue&type=style&index=0&id=a2e1f30a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e1f30a",
  null
  
)

export default component.exports